//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"AnalysisType",1,0],[0,"FixedVoxelSize",1,0],[0,"NumberOfFrequencies",1,0],[0,"OptimizationObjectiveType",1,0],[1,"ResolutionVoxelSize",0,"Expression",0],[0,"StudyName",1,0],[0,"StudyQuality",1,0],[0,"SubcaseSummationType",1,0]],[[["studyQualityFactor"],"SetResolutionVoxelSizeByStudyQuality",{},1,1]],[]];
SPLM.DesignSimulation.StudyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.StudyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.StudyBuilder.AnalysisOption = Object.freeze({
    "LinearStatics" : "LinearStatics", "NormalModes" : "NormalModes", "Thermal" : "Thermal"});

SPLM.DesignSimulation.StudyBuilder.SubcaseSummationOption = Object.freeze({
    "Maximum" : "Maximum", "Normalized" : "Normalized"});

SPLM.DesignSimulation.StudyBuilder.OptimizationObjectiveOption = Object.freeze({
    "MinimumMass" : "MinimumMass", "MinimumVolume" : "MinimumVolume", "MaximumStiffness" : "MaximumStiffness", "MaximumFirstFlexibleMode" : "MaximumFirstFlexibleMode"});

export default SPLM;